import { useMemo } from "react";

import { SitesContextType, useSitesContext } from "@/components/sites-provider";

export function useHasEnterpriseEdition(): boolean {
    const { sites = [] }: SitesContextType = useSitesContext();

    const hasEnterpriseEdition = useMemo(
        () =>
            sites.some((site) => site.edition?.toLowerCase() === "enterprise"),
        [sites]
    );

    return hasEnterpriseEdition;
}
